const UPLOAD_PHASE_MAX = 50;
const READING_PROGRESS = 75;
const CALCULATING_COVERAGE_PROGRESS = 90;

type UploadProgressInput = { progress?: number; status: string };

export const uploadProgress = ({ progress, status }: UploadProgressInput) => {
  if (status === "complete") {
    return 100;
  }
  if (status === "processing") {
    return READING_PROGRESS;
  }
  return ((progress ?? 0) / 100) * UPLOAD_PHASE_MAX;
};

export const combinedUploadProgress = (uploads: UploadProgressInput[], isCalculatingCoverage: boolean) => {
  if (isCalculatingCoverage) {
    return CALCULATING_COVERAGE_PROGRESS;
  }
  if (uploads.length === 0) {
    return 0;
  }
  return Math.round(uploads.reduce((sum, upload) => sum + uploadProgress(upload), 0) / uploads.length);
};
